import TheGrid from '@/views/campaigns/bestof/dsrobjectives/grid'
import Edit from '@/views/campaigns/bestof/dsrobjectives/edit'

export default {
  path: '/campaigns/bestof/dsr-objectives',
  redirect: '/campaigns/bestof/dsr-objectives/index',
  name: 'bestof_dsrobjectives',
  meta: {
    auth: {
      redirect: {
        name: 'bestof_dsrobjectives.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Bestof'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'bestof_dsrobjectives.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'bestof_dsrobjectives.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'bestof_dsrobjectives.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
